import React, { useEffect, useState } from "react";
import { Receipt } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const money = (n: number) => `$${Number(n || 0).toFixed(2)}`;

export function BillingSummary({ c }: { c: any }) {
  const [b, setB] = useState<any>(null);
  const load = () => api.get(`/admin/cases/${c.id}/billing-summary`).then((r) => setB(r.data)).catch(() => setB(null));
  useEffect(() => { load(); }, [c]);
  if (!b) return null;
  const toggle = async () => {
    try { await api.patch(`/admin/cases/${c.id}/billing-staff-only`, { on: !b.staff_only }); toast.success(!b.staff_only ? "Only the fees added by staff will be billed" : "Automatic fees will be billed again"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="card-soft overflow-hidden" data-testid="billing-summary">
      <div className="flex flex-wrap items-center justify-between gap-2 border-b border-slate-100 px-4 py-3">
        <h3 className="flex items-center gap-2 text-sm font-bold text-[#1B365D]"><Receipt className="h-4 w-4" /> What {b.company || "the client"} will be billed</h3>
        <span className="rounded-full bg-[#F1F5F9] px-2 py-0.5 text-xs font-semibold text-[#475569]" data-testid="billing-summary-type">{b.type}</span>
      </div>
      {b.omitted ? <p className="px-4 py-3 text-sm font-semibold text-[#B45309]" data-testid="billing-summary-omitted">Left off the invoice: this case won't be billed.</p> : (
        <ul className="divide-y divide-slate-100 text-sm">
          {!b.lines.length && <li className="px-4 py-2.5 text-[#64748B]">Nothing extra to bill: the search was prepaid with a code.</li>}
          {b.lines.map((l: any, i: number) => (
            <li key={i} className="flex justify-between gap-3 px-4 py-2.5" data-testid={`billing-summary-line-${i}`}>
              <span>{l.label} <span className="text-xs text-[#94A3B8]">{l.auto ? "added automatically" : "added by staff"}</span></span>
              <span className="font-mono">{money(l.amount)}</span>
            </li>
          ))}
          <li className="flex justify-between bg-[#F8FAFC] px-4 py-2.5 font-semibold"><span>Total on the monthly bill</span><span className="font-mono" data-testid="billing-summary-total">{money(b.total)}</span></li>
        </ul>
      )}
      {!b.omitted && (
        <label className="flex cursor-pointer items-start gap-2 border-t border-slate-100 px-4 py-3 text-sm" data-testid="billing-staff-only">
          <input type="checkbox" className="mt-0.5 h-4 w-4" checked={!!b.staff_only} onChange={toggle} data-testid="billing-staff-only-toggle" />
          <span><b>Don't bill the automatic fees</b><span className="block text-xs text-[#64748B]">Use when the base search and other automatic charges were already billed (for example a re-opened case). Only the fees added by staff below are billed. The Hyden $10 share is not counted again.</span></span>
        </label>
      )}
      <p className="px-4 pb-3 pt-2 text-xs text-[#94A3B8]">Fees marked "added automatically" come from the client's settings and the applicant's address history. Don't add them again below.</p>
    </div>
  );
}
